
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { myTheme } from '../../../../assets/styles/my-theme';

import { store } from '../../../../index';
import { reduxActions, RootState } from '../../../../store'
import { IFile } from '../../../../shared/interfaces';
import { DocumentCard, DocumentCardActions, DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, FontIcon, getFocusStyle, getTheme, IButtonProps, Icon, IDocumentCardPreviewProps, IDocumentCardStyles, ITheme, List, mergeStyleSets, Text } from '@fluentui/react';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import Utilities from '../../../../shared/Utilities/utilities';
import { RouteComponentProps } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import protocolsService from '../../../../services/protocols.service';
import axios, { CancelTokenSource } from 'axios';

const queryString = require('query-string');


const theme: ITheme = getTheme();
const { semanticColors, fonts } = theme;
const { palette } = myTheme;

const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    itemDimension: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
        padding: '0px 16px'
    },
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
    iconClass: {
        fontSize: 20,
        height: 20,
        width: 20,
    }
});





export interface FilesListProps {
    target: string
}
type Props = FilesListProps & RouteComponentProps

let cancelTokenSources = {};

const FilesList: React.FunctionComponent<Props> = props => {

    const selectCurrentProtocol = (state: RootState) => state.protocolWizardReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);


    useEffect(() => {
        // Anything in here is fired on component mount.


        return () => {
            // Anything in here is fired on component unmount.

            // cancello tutte le request in pending
            for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                value.cancel(`${key} canceled`)
            }

        }
    }, [])


    const onFileItemClick = (file: IFile | undefined) => {
        const parsedQueryString = queryString.parse(props.location.search);
        let aooId = Number(props.match.params["aooId"]);
        let uorId = Number(parsedQueryString.uorId);

        if (file && file.docBase64String) {
            if (file.extension === '.pdf')
                Utilities.OpenNewTabFormBase64String(`data:application/pdf;base64,` + file.docBase64String);
            else if (file.docBase64String) {

                Utilities.SaveFileFromBase64(file.docBase64String, file.fileName);
            }

        }
        if (currentProtocol && currentProtocol.id && file && file.id) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            cancelTokenSources[protocolsService.getFileSPById.name]?.cancel("Request annullata");
            cancelTokenSources[protocolsService.getFileSPById.name] = axios.CancelToken.source();


            file.loading = true;
            store.dispatch(reduxActions.protocolWizardActions.updateAttachment(file))
            protocolsService.getFileSPById(aooId, uorId, currentProtocol.id, file.id!, cancelTokenSources[protocolsService.getFileSPById.name].token)
                .then(fileResult => {
                    file.docBase64String = fileResult.docBase64String;
                    file.loading = false;
                    store.dispatch(reduxActions.protocolWizardActions.updateAttachment(file))
                    if (file && file.docBase64String) {
                        if (file.extension === '.pdf')
                            Utilities.OpenNewTabFormBase64String(`data:application/pdf;base64,` + file.docBase64String);
                        else if (file.docBase64String) {

                            Utilities.SaveFileFromBase64(file.docBase64String, file.fileName);
                        }

                    }
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    } else {
                        file.loading = false;
                        store.dispatch(reduxActions.protocolWizardActions.updateAttachment(file))

                        throw error;
                    }

                });
        }

    }


    const onRemoveFileItemClick = (ev, file: IFile | undefined) => {
        ev.stopPropagation();
        ev.preventDefault();

        switch (props.target) {
            case 'documento':
                store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: undefined }));
                break;
            case 'allegati':
                let newAttachments = currentProtocol?.attachments?.filter(it => it !== file);
                store.dispatch(reduxActions.protocolWizardActions.setProtocol({ attachments: newAttachments }));

                break;

        }


    }


    const fileRenderIcon = (item) => {
        if (item.loading) {
            return <div style={{ fontSize: 20 }}> <FontAwesomeIcon icon={['fal', 'circle-notch']} spin /></div>;
        }
        else if (item.extension.toLowerCase() === '.p7m') {
            return <FontIcon aria-label="file p7m" iconName="Certificate" className={classNames.iconClass} />
       }
        else
            return <Icon {...getFileTypeIconProps({ extension: item.extension, size: 20 })} />;

    }


    const fileRenderCell = (item: any) => {
        const documentCardSyles: Partial<IDocumentCardStyles> = {
            root: {
                height: 65,
                backgroundColor: !item.enabled ? 'rgb(243, 242, 241)' : 'unset',
                color: !item.enabled ? 'rgb(161, 159, 157)' : 'unset',
                '&:hover': {
                    cursor: item.enabled ? 'pointer' : 'unset',

                }
            },

        }

        const previewPropsUsingIcon: IDocumentCardPreviewProps = {
            previewImages: [
                {
                    previewIconProps: {
                        children: fileRenderIcon(item)
                    },
                    width: 63,

                }
            ],
            styles: {
                previewIcon: { backgroundColor: palette.neutralLighterAlt },
            },

        };
        let actions: IButtonProps[] = [];
        actions.push({
            iconProps: { iconName: 'Delete' },
            onClick: (ev) => onRemoveFileItemClick(ev, item),
            ariaLabel: 'Elimina',
        })
        let fileName = item.originalName ? item.originalName : item.fileName;

        return (
            <DocumentCard
                aria-label={fileName}
                type={DocumentCardType.compact}
                onClick={() => onFileItemClick(item)}
                styles={documentCardSyles}
            >
                <DocumentCardPreview {...previewPropsUsingIcon} />
                <DocumentCardDetails>
                    <DocumentCardTitle title={fileName} className={classNames.itemName} />
                    <div className={classNames.itemDimension}>{AppUtilities.GetDimensionFileString(item)}</div>
                </DocumentCardDetails>
                <DocumentCardActions
                    actions={actions} />

            </DocumentCard>
        );


    };

    const showFileList = () => {
        switch (props.target) {
            case 'documento':
                if (currentProtocol?.documentFile?.docBase64String) {
                    return fileRenderCell(currentProtocol?.documentFile);
                }
                else
                    return <Text nowrap block>
                        Nessun documento caricato
                    </Text>

                break;
            case 'allegati':
                if (currentProtocol?.attachments && currentProtocol?.attachments.length > 0)
                    return <List items={currentProtocol?.attachments} onRenderCell={fileRenderCell} />
                else
                    return <Text nowrap block>
                        Nessun allegato caricato
                    </Text>
                break;
        }
    }

    return <React.Fragment>

        {showFileList()}

    </ React.Fragment>

};


export default FilesList;



